import logService from "src/services/logService";
import userService from "src/services/userService";

export const GET_LOG_REQUEST = "@log/get-log-request";
export const GET_LOG_SUCCESS = "@log/get-log-success";
export const GET_LOG_FAILURE = "@log/get-log-failure";

export const GET_LOG_DETAIL_REQUEST = "@log/get-log-detail-request";
export const GET_LOG_DETAIL_SUCCESS = "@log/get-log-detail-success";
export const GET_LOG_DETAIL_FAILURE = "@log/get-log-detail-failure";

export function getListLog(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LOG_REQUEST});
      const response = await logService.getListLog(params);
      dispatch({
        type: GET_LOG_SUCCESS,
        payload: {
          response: response.data.data,
          total: response.headers["x-total-items"]
        }
      });
    } catch (error) {
      dispatch({type: GET_LOG_FAILURE});
      throw error;
    }
  };
}

export function getDetailLog(logId) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LOG_DETAIL_REQUEST});
      if (logId) {
        const response = await logService.getDetailLog(logId);
        if (response) {
          const user = await userService.getOneUser(response.created_by);
          if (user) response.created_name = user.first_name + user.last_name;
          dispatch({
            type: GET_LOG_DETAIL_SUCCESS,
            payload: {
              response
            }
          });
        }
      } else {
        dispatch({
          type: GET_LOG_DETAIL_SUCCESS,
          payload: {}
        });
      }
    } catch (error) {
      dispatch({type: GET_LOG_DETAIL_FAILURE});
      throw error;
    }
  };
}
